import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function AngiesList(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#D7FFED" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        d="M15.031 5.13H12.0564L11.0402 11.4731C11.0191 11.4766 10.998 11.4766 10.9734 11.4801C8.7266 11.779 6.97909 13.6706 7.00019 15.7873C7.00722 16.6734 7.30961 17.3625 7.85109 17.9286C8.32576 18.4314 8.98679 18.7162 9.67946 18.7198C9.94669 18.7198 10.2104 18.6776 10.46 18.5897C11.6731 18.1712 12.0739 17.1551 12.2638 16.2233V16.2268C12.3165 15.1896 11.7645 14.1629 10.7062 13.5546L10.3721 15.6678C10.2631 16.269 10.126 16.6277 9.82362 16.7296C9.6443 16.7929 9.42279 16.7261 9.27511 16.5714C9.08173 16.371 8.96921 16.146 8.96569 15.7662C8.95515 14.7079 9.78846 13.8781 10.7062 13.5546C11.0015 13.4491 11.3145 13.3964 11.6274 13.3999C11.9755 13.4034 12.3236 13.4632 12.6506 13.5757C13.8918 13.8675 14.6407 15.1826 14.827 16.6066L14.936 17.4047H17L15.031 5.13ZM12.9143 11.6102L13.5085 7.0709H13.5788L14.2399 12.1376C13.8214 11.9091 13.3749 11.7297 12.9143 11.6102Z"
        fill="#FF6153"
      />
      <path
        d="M12.2638 16.2306C12.3693 15.7875 12.6084 14.0822 12.6506 13.5794C12.32 13.4669 11.9755 13.4071 11.6274 13.4036C11.3144 13.4001 11.0015 13.4528 10.7026 13.5583C11.761 14.1631 12.3165 15.1898 12.2638 16.2306Z"
        fill="#A03027"
      />
    </svg>
  );
}

AngiesList.propTypes = propTypes;
AngiesList.defaultProps = defaultProps;

export default AngiesList;
